export enum ProjectStatuses {
  CREATED = 'created',
  PREPROCESSING = 'preprocessing',
  PREPROCESSING_UPDATE = 'preprocessing update',
  PREPROCESSING_COMPLETE = 'preprocessing complete',
  PREPROCESSING_UPDATE_COMPLETE = 'preprocessing update complete',
  NETWORK_PROCESSING = 'network processing',
  NETWORK_PROCESSING_UPDATE = 'network processing update',
  NETWORK_COMPLETE = 'network complete',
  NETWORK_UPDATE_COMPLETE = 'network update complete',
  CLUSTERING_UPDATE_COMPLETE = 'clustering update complete',
  COMPLETE = 'complete',
  ERROR = 'error',
}
